const DEBUG_QUERY_PARAM = "meditationDebug";
const VERBOSE_DEBUG_QUERY_PARAM = "meditationDebugVerbose";

function hasDebugFlag(name: string) {
    if (typeof window === "undefined") {
        return false;
    }

    const location = window.location;
    const search = typeof location?.search === "string" ? location.search : "";
    const href =
        typeof location?.href === "string" && location.href.length > 0
            ? location.href
            : `http://localhost/${search.startsWith("?") ? search : ""}`;

    try {
        const url = new URL(href);
        if (url.searchParams.get(name) === "1") {
            return true;
        }
    } catch {
        if (new URLSearchParams(search).get(name) === "1") {
            return true;
        }
    }

    try {
        return window.localStorage.getItem(name) === "1";
    } catch {
        return false;
    }
}

export function isMeditationDebugEnabled() {
    return (
        hasDebugFlag(DEBUG_QUERY_PARAM) ||
        hasDebugFlag(VERBOSE_DEBUG_QUERY_PARAM)
    );
}

export function isMeditationVerboseDebugEnabled() {
    return hasDebugFlag(VERBOSE_DEBUG_QUERY_PARAM);
}

export function meditationDebugLog(...args: unknown[]) {
    if (!isMeditationDebugEnabled()) {
        return;
    }

    console.info(...args);
}

export function meditationVerboseDebugLog(...args: unknown[]) {
    if (!isMeditationVerboseDebugEnabled()) {
        return;
    }

    console.info(...args);
}

export function meditationDebugWarn(...args: unknown[]) {
    if (!isMeditationDebugEnabled()) {
        return;
    }

    console.warn(...args);
}

export function meditationVerboseDebugWarn(...args: unknown[]) {
    if (!isMeditationVerboseDebugEnabled()) {
        return;
    }

    console.warn(...args);
}
